// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hUEMh","type":"styles_type__2xq_L","choices":"styles_choices__31Z4b"};